import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'
import createPersistedState from 'vuex-persistedstate'
import { DEFAULT_OBJECT_CATEGORY } from '@/components/common/constants.js'
Vue.use(Vuex)
import lodash from 'lodash'
Vue.use(lodash)
const state = {
  search: [],
  totalResult: 0,
  searchType: 'all',
  searchText: '',
  startIndex: 0,
  lastIndex: 0,
  searchPrice: [],
  // isSearchClicked: false,
  mostSearchedWordList: []
}
// var result = []
const getters = {
  getTotalResultLength (state) {
    return state.totalResult
  },
  getFirstIndex (state) {
    return state.startIndex
  },
  getLastIndex (state) {
    return state.lastIndex
  },
  getSearchPrice (state) {
    return state.searchPrice
  },
  getSearchText (state) {
    return state.searchText
  },
  getSearchType (state) {
    return state.searchType
  },
  getSearchStoreData: function (state) {
    return state.search
  },
  getMostSearchedWordList: function (state) {
    return state.mostSearchedWordList
  },
  // returns result matching filters
  getFilteredData: (state, getters) => searchParameters => {
    var searchResult = []
    // check if user has selected category filter
    if (searchParameters.categorySelected.length !== 0 && searchParameters.categorySelected !== null) {
      for (let i = 0; i < getters.getSearchStoreData.length; i++) {
        for (let j = 0; j < searchParameters.categorySelected.length; j++) {
          if (getters.getSearchStoreData[i].category.includes(searchParameters.categorySelected[j])) {
            searchResult.push(getters.getSearchStoreData[i])
          } else {
            if ((j + 1) === searchParameters.categorySelected.length) {
              break
            }
          }
        }
      }
    }
    // check if user has selected language filter
    if (searchParameters.languageSelected.length !== 0 && searchParameters.languageSelected !== null) {
      // perform action on result obtained after category filter
      if (searchResult.length !== 0) {
        let tmp = []
        for (let i = 0; i < searchResult.length; i++) {
          for (let j = 0; j < searchParameters.languageSelected.length; j++) {
            if (searchResult[i].languageId.includes(searchParameters.languageSelected[j])) {
              tmp.push(searchResult[i])
              break
            }
          }
        }
        searchResult = tmp
      } else {
        // check if user has not selected category filter
        if (searchParameters.categorySelected.length === 0) {
          for (let i = 0; i < getters.getSearchStoreData.length; i++) {
            for (let j = 0; j < searchParameters.languageSelected.length; j++) {
              if (getters.getSearchStoreData[i].languageId.includes(searchParameters.languageSelected[j])) {
                var isObjExists = false
                for (let k = 0; k < searchResult.length; k++) {
                  if (searchResult[k].contentId === getters.getSearchStoreData[i].contentId) {
                    isObjExists = true
                    break
                  }
                }
                if (!isObjExists) {
                  searchResult.push(getters.getSearchStoreData[i])
                }
              } else {
                if ((j + 1) === searchParameters.languageSelected.length) {
                  break
                }
              }
            }
          }
        }
      }
    }
    // check if user has selected duration filter
    if (searchParameters.duration !== null && searchParameters.duration.length !== 0) {
      // perform action on result obtained after category filter & language filter
      if (searchResult.length !== 0) {
        if (searchParameters.duration === 0) {
          searchResult = lodash.orderBy(searchResult, ['price'], ['asc'])
        } else {
          searchResult = lodash.orderBy(searchResult, ['price'], ['desc'])
        }
      } else {
        // check if user has not selected category filter and language
        if (searchParameters.languageSelected.length === 0 && searchParameters.categorySelected.length === 0) {
          if (searchParameters.duration === 0) {
            searchResult = lodash.orderBy(getters.getSearchStoreData, ['price'], ['asc'])
          } else {
            searchResult = lodash.orderBy(getters.getSearchStoreData, ['price'], ['desc'])
          }
        }
      }
    }
    // check if user has selected cost filter
    if (searchParameters.cost.length !== 0 && searchParameters.cost !== null) {
      // perform action on result obtained after category filter , language filter & cost filter
      if (searchResult.length !== 0) {
        let tmp = []
        for (let i = 0; i < searchResult.length; i++) {
          if (searchParameters.cost[0] <= searchResult[i].price && searchResult[i].price <= searchParameters.cost[1]) {
            tmp.push(searchResult[i])
          }
        }
        searchResult = tmp
      } else {
        // check if user had not selected category filter , language filter & cost filter
        if (searchParameters.categorySelected.length === 0 && searchParameters.languageSelected.length === 0 && searchParameters.duration.length === 0) {
          for (let i = 0; i < getters.getSearchStoreData.length; i++) {
            if (searchParameters.cost[0] <= getters.getSearchStoreData[i].price && getters.getSearchStoreData[i].price <= searchParameters.cost[1]) {
              searchResult.push(getters.getSearchStoreData[i])
            }
          }
        }
      }
    }
    return searchResult
  }
}
const actions = {
  // change search text
  changeSearchText (context, data) {
    context.commit('setSearchText', data)
  },
  // reset search text
  clearSearchText (context) {
    context.commit('clearSearchText')
  },
  // set earch type : all/LO/CO
  changeSearchType (context, data) {
    context.commit('setSearchType', data)
  },
  getMostSearchedWordList (context, data) {
    return new Promise(function (resolve, reject) {
      var profileId = null
      var profileDetails = context.getters.getProfileDetails
      if (profileDetails !== null && profileDetails.profileId !== null) {
        profileId = profileDetails.profileId
      }
      axios
        .post('o/getMostSearchedWordList', {
          'userId': profileId
        }).then(function (response) {
          context.commit('setMostSearchedWordList', response.data)
          resolve(response.data)
        }).catch(function (e) {
          reject(e)
        })
    })
  },
  // stores search result
  // called on first search
  getSearchResult (context, data) {
    // save search Text
    context.commit('setSearchText', data.searchText)
    data['startIndex'] = 0
    data['lastIndex'] = 5
    data['type'] = context.getters.getSearchType
    return new Promise((resolve, reject) => {
      var objectCategory = ''
      if (context.getters.getProfileDetails === undefined || context.getters.getProfileDetails === null || Object.keys(context.getters.getProfileDetails).length === 0 && context.getters.getProfileDetails.constructor === Object) {
        // console.log('here')
        objectCategory = DEFAULT_OBJECT_CATEGORY
      } else {
        objectCategory = context.getters.getUserJvID(context.getters.getProfileDetails.accountDetails)
        // console.log(objectCategory)
      }
      axios.post('o/getsearchresult', data, {headers: {'contentCategory': objectCategory}}).then(response => {
        // set total no of result used to stop lazy loading
        context.commit('setTotalLength', parseInt(response.headers.totalresult))
        // store search result
        context.commit('setSearchStoreData', response.data)
        resolve()
      }).catch(error => {
        console.log('catch', error)
        reject(error)
      })
    })
  },
  // stores result for lazyLoading
  appendSearchResult (context, data) {
    // set startIndex & lastIndex
    context.commit('setIndexes', {'startIndex': data.startIndex, 'lastIndex': data.lastIndex})
    data['type'] = context.getters.getSearchType
    return new Promise((resolve, reject) => {
      var objectCategory = ''
      if (context.getters.getProfileDetails === undefined || context.getters.getProfileDetails === null || Object.keys(context.getters.getProfileDetails).length === 0 && context.getters.getProfileDetails.constructor === Object) {
        objectCategory = DEFAULT_OBJECT_CATEGORY
      } else {
        objectCategory = context.getters.getUserJvID(context.getters.getProfileDetails.accountDetails)
      }
      axios.post('o/getsearchresult', data, {headers: {'contentCategory': objectCategory}}).then(response => {
        // get old result
        var oldResult = context.getters.getSearchStoreData
        // append new result to old
        for (let i = 0; i < response.data.length; i++) {
          oldResult.push(response.data[i])
        }
        // save result (old + new)
        context.commit('setSearchStoreData', oldResult)
        resolve()
      }).catch(error => {
        console.log('catch', error)
        reject(error)
      })
    })
  },
  // clears search store
  removePreviousSearchResult (context) {
    context.commit('clearSearchStoreData')
  },
  // set index
  setIndexesOnSearch (context) {
    context.commit('setIndexes', {'startIndex': 0, 'lastIndex': 5})
  }
}
const mutations = {
  resetMostSearchWordList (state) {
    state.mostSearchedWordList = []
  },
  setIndexes (state, data) {
    state.startIndex = data.startIndex
    state.lastIndex = data.lastIndex
  },
  setTotalLength (state, data) {
    state.totalResult = data
  },
  setSearchStoreData (state, data) {
    if (data === null || data.length === 0) {
      state.search = []
      state.searchPrice = [0, 0]
      state.startIndex = 0
      state.lastIndex = 0
      state.totalResult = 0
    } else {
      if (data.length > 0) {
        state.search = data
        if (state.lastIndex === 0) {
          state.startIndex = 0
          state.lastIndex = 5
        }
        // compute max price
        var max = data[0].price
        for (let i = 1; i < data.length; i++) {
          if (data[i].price > max) {
            max = data[i].price
          }
        }
        state.searchPrice = [0, max]
      }
      // else {
      //  state.searchPrice = [0, 0]
      // }
    }
  },
  setSearchPrice (state, data) {
    state.searchPrice[0] = data.low
    state.searchPrice[1] = data.high
  },
  setMostSearchedWordList (state, data) {
    if (data === null) {
      state.mostSearchedWordList = []
    } else {
      state.mostSearchedWordList = data
    }
  },
  clearSearchStoreData (state, data) {
    state.search = []
    state.searchPrice = []
    state.totalResult = 0
    state.searchText = ''
    state.startIndex = 0
    state.lastIndex = 0
    state.searchPrice = []
    // state.isSearchClicked = false
  },
  setSearchText (state, data) {
    state.searchText = data
  },
  clearSearchText (state, data) {
    state.searchText = ''
  },
  setSearchType (state, data) {
    state.searchType = data
  },
  resetSearchType (state, data) {
    state.searchType = 'all'
  }
}
export default {
  state,
  actions,
  getters,
  mutations,
  plugins: [createPersistedState({ storage: window.localStorage })]
}



// WEBPACK FOOTER //
// ./src/store/modules/search.js